module.exports = __webpack_public_path__ + "static/about-us-sinead-video-screenshot-be31f1f8b2fa04156950dd2a2204cba1.jpg";